import { useEffect } from 'react'
import { setClientDeviceCookies } from '~/utils/setClientDeviceCookies'

export function SetClientDeviceCookies() {
  useEffect(() => {
    setClientDeviceCookies()
  }, [])

  return null
}
